import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";
import {SubscribeComponent} from "../../common/subscribe/subscribe.component";
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-patenschaft',
  standalone: true,
    imports: [
        RouterLink,
        SubscribeComponent,
        NgForOf
    ],
  templateUrl: './patenschaft.component.html',
  styleUrl: './patenschaft.component.scss'
})
export class PatenschaftComponent {
    dummyArray = Array(36);


}
